import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

import { App } from "./App";
import { initObs } from "./obs";
import "./index.css";

// Antes do render: erro durante a montagem também precisa ser reportado.
initObs();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/*
      Fallback de último recurso. O ErrorBoundary interno (por rota) trata o
      caso comum e mantém a navegação viva; este aqui só existe pra quando a
      árvore inteira cai — sem ele o usuário fica com a tela branca e nós
      não ficamos sabendo.
    */}
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
          <p className="text-sm font-medium text-slate-800 dark:text-slate-100">
            Algo quebrou nesta tela.
          </p>
          <p className="max-w-sm text-xs text-slate-500 dark:text-slate-400">
            O erro foi registrado. Recarregar costuma resolver — se voltar a
            acontecer, avise o suporte.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md bg-brand-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-brand-500"
          >
            Recarregar
          </button>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
